import { Provider } from 'react-redux';
import { store } from '../store/store';

/**
 * Redux Provider wrapper component
 *
 * Wraps the application with Redux Provider to make the store
 * available to all components via hooks.
 *
 * Usage in main.jsx:
 *   <ReduxProvider>
 *     <App />
 *   </ReduxProvider>
 */
export function ReduxProvider({ children }) {
  return <Provider store={store}>{children}</Provider>;
}
